import type { FC } from 'react';
import type { TGlobalCompensationProps } from '@components/Organisms/GlobalCompensation/GlobalCompensation.types';
import { getCompensationPackageValues } from '@components/Organisms/GlobalCompensation/_helpers/bonuses-and-benefits';
import { GlobalCompensationTotal } from '@components/Organisms/GlobalCompensation/_partials/GlobalCompensationTotal';
import { GlobalCompensationDetails } from '@components/Organisms/GlobalCompensation/_partials/GlobalCompensationDetails';

export const GlobalCompensation: FC<TGlobalCompensationProps> = ({
  candidate,
  isDesired = false,
}) => {
  if (!candidate) {
    return null;
  }

  const { annualSalary, benefits, bonuses, contractLevel, isEstimated, total } =
    getCompensationPackageValues({ candidate, isDesired });

  return (
    <div className="c-global-compensation">
      <GlobalCompensationTotal
        contractLevel={contractLevel}
        isDesired={isDesired}
        isEstimated={isEstimated}
        isFreelancer={candidate.isFreelancer}
        total={total}
      />

      <GlobalCompensationDetails
        annualSalary={annualSalary}
        benefits={benefits}
        bonuses={bonuses}
      />
    </div>
  );
};
